export const getIsFetching = state => state.validateToken.isFetching;
export const getErrorMessage = state => state.validateToken.errorMessage;
